
import React from "react";
export default function HowItWorks() {
  return (
    <section id="term-insurance-education" className="lg:tw-py-20 tw-py-10 tw-bg-white">
      <div className="tw-max-w-6xl tw-mx-auto tw-px-6">
        <div className="tw-text-center tw-mb-16">
          <h2 className="tw-text-2xl lg:tw-text-4xl tw-font-bold tw-text-fintoo-blue tw-mb-6">
            Why Term Insurance Matters?
          </h2>
          <p className="tw-text-lg  lg:tw-text-xl  tw-text-gray-700 tw-max-w-4xl tw-mx-auto tw-leading-relaxed">
            Term insurance is the simplest, most affordable form of life
            insurance. You pay a small premium to secure a large cover, ensuring
            your family's financial stability in your absence.
          </p>
        </div>

        <div className="tw-grid tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-8">
          <div className="tw-text-center tw-space-y-4">
            <div className="tw-w-16 tw-h-16 tw-bg-gradient-to-b tw-from-fintoo-blue tw-to-[#1b53a3] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mx-auto">
              <i className="fa-solid fa-rupee-sign tw-text-white tw-text-2xl"></i>
            </div>
            <h3 className="tw-text-xl tw-font-bold tw-text-fintoo-blue pb-0">
              Affordable Premiums
            </h3>
            <p className="tw-text-gray-600">Get higher cover at lower cost.</p>
          </div>

          <div className="tw-text-center tw-space-y-4">
            <div className="tw-w-16 tw-h-16 tw-bg-fintoo-orange tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mx-auto">
              <i className="fa-solid fa-percent tw-text-white tw-text-2xl"></i>
            </div>
            <h3 className="tw-text-xl tw-font-bold tw-text-fintoo-blue pb-0">
              Tax Benefits
            </h3>
            <p className="tw-text-gray-600">
              Save more with Section 80C &amp; 10(10D).
            </p>
          </div>

          <div className="tw-text-center tw-space-y-4">
            <div className="tw-w-16 tw-h-16 tw-bg-gradient-to-b tw-from-fintoo-blue tw-to-[#1b53a3] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mx-auto">
              <i className="fa-solid fa-hand-holding-dollar tw-text-white tw-text-2xl"></i>
            </div>
            <h3 className="tw-text-xl tw-font-bold tw-text-fintoo-blue pb-0">
              Peace of Mind
            </h3>
            <p className="tw-text-gray-600">
              Ensure financial stability for your family.
            </p>
          </div>

          <div className="tw-text-center tw-space-y-4  ">
            <div className="tw-w-16 tw-h-16 tw-bg-fintoo-orange tw-rounded-full tw-flex tw-items-center tw-justify-center tw-mx-auto">
              <i className="fa-solid fa-shield-heart tw-text-white tw-text-2xl"></i>
            </div>
            <h3 className="tw-text-xl tw-font-bold tw-text-fintoo-blue tw-pb-0">
              Pure Protection
            </h3>
            <p className="tw-text-gray-600">
              No hidden frills, just guaranteed security.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};